module.exports = __webpack_public_path__ + "img/logo.63a289c2.png";